// Copyright (c) 2017 Deere & Company

import RecordAudit from './record-audit';
import actionCreators from '../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.tcsm.recordAudit
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    queryParams: parentProps.location.query,
    routeParams: parentProps.routeParams
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(RecordAudit);



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/components/index.js